import React from "react";
import { Typography, Paper, Box, Link } from "@mui/material";

function About() {
  return (
    <Box
      sx={{
        backgroundColor: "#f4f9ff",
        minHeight: "100vh",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <div className="header">
        <img src="/logo.png" alt="Logo" className="logo" />
        <div className="heading-text">
          <br />
          <h1 className="title">Smart Parking App</h1>
          <p className="caption">"Empowering Digital India .."</p>
        </div>
      </div>
      <h1 className="title">About the Smart Parking App</h1>

      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          maxWidth: 600,
          width: "90%",
          mx: "auto",
        }}
      >
        <Typography variant="body1" gutterBottom>
          The Smart Parking App is a digital solution designed to streamline parking management across the Kalimpong Municipality area. It offers a convenient, efficient, and user-friendly platform for two-wheeler riders to access parking services, pay securely and manage receipts—all while supporting the vision of a digitally empowered India.
        </Typography>

        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
          Features & How to Use
        </Typography>
        <ul style={{ paddingLeft: "20px", margin: 0 }}>
          <li>
            <Typography variant="body1">
              <strong>Easy Parking Access:</strong> Find and pay for parking in zones like Damber Chowk, 9th Mile, 10th Mile and Thana Dara.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Flexible Payment Options:</strong> Choose hourly, daily, or monthly plans with secure payment methods.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Digital Receipts:</strong> View and download parking receipts instantly via the app.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>How to Use:</strong> Enter your vehicle number, select a parking zone, choose a duration, and complete payment—all in a few taps!
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Renewals Made Simple:</strong> Extend parking duration seamlessly if your receipt expires.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Policy Links for this Service
        </Typography>
        <hr />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Link href="/pricing" underline="hover" color="primary">
            Parking Pricing
          </Link>
          <Link href="/contact" underline="hover" color="primary">
            Contact Us
          </Link>
          <Link href="/terms" underline="hover" color="primary">
            Terms & Conditions
          </Link>
          <Link href="/privacy" underline="hover" color="primary">
            Privacy Policy
          </Link>
          <Link href="/refund" underline="hover" color="primary">
            Cancellation & Refund Policy
          </Link>
          <Link href="/shipping" underline="hover" color="primary">
            Shipping Policy
          </Link>
          <br />
          <hr />
          <Typography variant="body1">Version - v0.0.0</Typography>
        </Box>
      </Paper>
    </Box>
  );
}

export default About;